import React, { useRef, useState } from "react";
import { FormInstance, Button, Form, message } from "antd";

import classes from "./Otp.module.css";
import AuthScreenContainer from "containers/AuthScreenContainer";
import CustomBoxOtpInput from "components/customOtpBoxInput";
import { useNavigate } from "react-router-dom";

export const OtpForm = ({
  email,
  next,
  verify
}: {
  email: string;
  next: (data: any) => void;
  verify: (email: string, otp: number) => Promise<any>;
}) => {
  const [loading, setLoading] = useState(false);
  const [otp, setOtp] = useState("");
  const formRef = useRef<FormInstance>(null);
  const verificationAttempts = useRef(0);
  const navigate = useNavigate();

  const handleSubmit = async () => {
    if (!otp) {
      message.error("Please enter OTP");
      return;
    }

    setLoading(true);
    const res = await verify(email, Number(otp));
    setLoading(false);

    if (!res) {
      verificationAttempts.current += 1;
      if (verificationAttempts.current > 2) {
        message.error("Incorrect OTP entered 3 times. Please resend the OTP to try again.")
        navigate("/")
      }
      return;
    }

    next(res.data.data);
  };

  return (
    <AuthScreenContainer
      heading="Enter OTP"
      subHeading="Enter the verification code sent to your email address."
      footerLink="/login"
      footerLinkText="Sign in"
      footerText="Already have an account?">
      <div className={classes.ForgetPassword}>
        <Form className="Form" ref={formRef} onFinish={handleSubmit} style={{ width: "100%", display: "flex", flexDirection: "column", justifyContent: "center" }}>
          <CustomBoxOtpInput 
            value={otp} 
            setValue={setOtp} 
            disabled={loading} 
            otpContainerStyles={{ display: "flex", justifyContent: "center" }}
          />

          <Button
            loading={loading}
            disabled={loading || otp.length !== 6}
            className={classes.ForgetPasswordButton}
            onClick={(e) => {
              e.preventDefault();
              formRef.current?.submit();
            }}
            htmlType="submit">
            Verify Email
          </Button>
        </Form>
      </div>
    </AuthScreenContainer>
  );
};
